import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const colorMap: Record<string, { bg: string; iconBg: string; text: string; border: string }> = {
  primary: {
    bg: 'hover:bg-primary-50',
    iconBg: 'bg-primary-100',
    text: 'text-primary-600',
    border: 'border-primary-100',
  },
  accent: {
    bg: 'hover:bg-accent-50',
    iconBg: 'bg-accent-100',
    text: 'text-accent-600',
    border: 'border-accent-100',
  },
  secondary: {
    bg: 'hover:bg-secondary-50',
    iconBg: 'bg-secondary-100',
    text: 'text-secondary-600',
    border: 'border-secondary-100',
  },
};

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            探索婚姻指南
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            从角色适应到自我成长，六个维度全面覆盖新婚生活的方方面面
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group p-5 md:p-6 rounded-xl border ${colors.border} bg-white transition-all duration-300 ${colors.bg}`}
              >
                <div className={`w-12 h-12 rounded-xl ${colors.iconBg} flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110`}>
                  <i className={`${cat.icon} ${colors.text} text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">{cat.name}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{cat.description}</p>
                <span className={`text-xs font-medium ${colors.text}`}>{cat.articleCount} 篇文章</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}